import WorkScheduleProvider from "./context/work-schedule-context.jsx";
import WorkScheduleFormCreate from "./work-schedule-form-create.jsx";

const WorkScheduleFormCreateInit = () => {

    return(
        <WorkScheduleProvider>
            <WorkScheduleFormCreate/>
        </WorkScheduleProvider>
    )
}

export default WorkScheduleFormCreateInit